export const trackerTranslations = {
    fa: {
        title: "مقایسه ردیاب‌های هوشمند",
        subtitle: "دلبند",
        description: "ویژگی‌های ردیاب‌های هوشمند مختلف دلبند را مقایسه کنید تا بهترین انتخاب را برای نیازهای خود داشته باشید.",
    },
    en: {
        title: "Smart Tracker Comparison",
        subtitle: "Delband",
        description: "Compare different Delband smart tracker features to make the best choice for your needs.",
    },
    ar: {
        title: "مقارنة أجهزة التتبع الذكية",
        subtitle: "دلبند",
        description: "قارن بين ميزات أجهزة تتبع دلبند الذكية المختلفة لاتخاذ الخيار الأفضل لاحتياجاتك.",
    },
    tr: {
        title: "Akıllı Takip Cihazı Karşılaştırması",
        subtitle: "Delband",
        description: "İhtiyaçlarınız için en iyi seçimi yapmak üzere farklı Delband akıllı takip cihazı özelliklerini karşılaştırın.",
    },
};
